import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { getDDLValueByLabel } from "../../../common/Common";

interface IYearToDateReportHeader {
	employeeDDLItems: any;
	yearDDLItems: any;
	payPeriodDDLItems: any;
	setStateRunGetListAPICall: (value: boolean) => void
	taxYear: any;
}

export const YearToDateReportHeader: React.FC<
	IYearToDateReportHeader
> = ({ yearDDLItems, employeeDDLItems, payPeriodDDLItems, setStateRunGetListAPICall, taxYear }) => {
	return (


		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					{yearDDLItems && <EnhancedDropDownRHFWithLabel
						selectName={"selectedYear"}
						items={yearDDLItems ?? []}
						// selectedItem={yearDDLItems && yearDDLItems.find((item: any) => item.label === taxYear).value}
						// selectedItem={taxYear}
						label={"Selected Year"}
						testId={"selected=year-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						showEmpty
					/>}
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeType"}
						items={[
							{ label: "All", value: "all" },
							{ label: "Regular Employee", value: 200 },
							{ label: "Only for T4/RL-1", value: 100 },
						]}
						label={"Employee Type"}
						testId={"employee-type"}
						selectedItem={"all"}
					// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						onClickHandler={() => setStateRunGetListAPICall(false)}
					/>

				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriod"}
						items={payPeriodDDLItems ?? []}
						selectedItem={"all"}
						label={"Pay Period"}
						testId={"pay-period-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
					<EnhancedDropDownRHFWithLabel
						selectName={"employee"}
						items={employeeDDLItems ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", marginTop: "1.4rem", paddingLeft: "2rem" }}>
					<span style={{ height: "10px", width: "10px", background: "rgb(186, 216, 168)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Cash Earnings</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(228, 243, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Non-Cash Earnings</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(255, 228, 248)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Deductions</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(248, 255, 188)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Non-Cash Dedutions</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(252, 219, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Reimbursement</span>

				</Grid>
			</Grid>
		</>
	);
};
